import {FC, useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import {setContractTableArchive} from '../../modules/contracts/stores/contracts-table.store';

export const ContractsLayout: FC = () => {
  useEffect(() => {
    return () => setContractTableArchive(false);
  }, []);

  return <Outlet />;
};
